export const METERING_POINT_FORM = 'METERING_POINT_FORM';
